import { Toaster as SonnerToaster } from 'sonner';
import { FC } from 'react';

type Props = {
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  richColors?: boolean;
  closeButton?: boolean;
};

export const Toaster: FC<Props> = ({ position = 'top-right', richColors = true, closeButton = true }) => {
  return <SonnerToaster position={position} richColors={richColors} closeButton={closeButton} />;
};
